import React, { useEffect } from 'react';
import SmsVerificationContainer from '../pages/SmsVerification';
import ProfilePhotoVerify from '../pages/ProfileVerify/ProfilePhotoVerify';
import NiceModal from "@ebay/nice-modal-react";
import { MemberProps } from '../typings/member';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../redux/store';
import { resetUserData } from '../redux/member';
import { resetMoodData } from '../redux/mood';
import { reset } from '../redux/app';
import { resetSignupQuestions } from '../redux/signupQuestions';
import { resetSignupData } from '../redux/signup';
import { resetCarpet } from '../redux/carpet';
import account from '../services/accountService';
import { ONBORADING_SCREEN } from '../navigation/Constants';
import { deleteMemberPushToken } from '../services/memberService';

type props = {
    member: MemberProps
}

const NeedToVerifyProfile = ({ member, children }: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { hubConnection } = useSelector((state: RootState) => state.app);

    // useEffect(() => {
    // NiceModal.show("action_modal", {
    //     onNext: () => NiceModal.hide("action_modal"),
    //     headerTitle: "אימות פרופיל",
    //     contentTitle: "החשבון שלך חוייב באימות פרופיל, כדי להמשיך אמת את מספר הטלפון ולאחר מכן את התמונה שלך, לאחר בדיקה ישלח sms במידה והפרופיל אושר או לא.",
    //     seconderyButtonText: "בהזדמנות אחרת",
    //     primaryButtonText: "המשך",
    //     showCloseButton: false,
    //     showSeconderyButton: false,
    //     isWelcomeModal: false
    // });
    // }, [])

    const clearReduxStoreDate = () => {
        dispatch(resetUserData());
        dispatch(resetMoodData());
        dispatch(reset());
        dispatch(resetSignupQuestions());
        dispatch(resetSignupData());
        dispatch(resetCarpet());

    };

    const logout = () => {
        if (window.platform === 'android' || window.platform === 'ios') {
            deleteMemberPushToken(member.memberCode);
        }
        account.logout();
        clearReduxStoreDate();
        hubConnection?.invoke("connectionClosed", member.memberCode);
        hubConnection?.stop();
        history.replace(ONBORADING_SCREEN);
    };



    if (!member.mediaRequierVerification || (member.hasBeenAuthenticatedByPhone && member.profileIsVerified)) return children
    else if (member.mediaRequierVerification && member.profileRequierdVerification && !member.profileIsVerified) return (
        <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
                <div className="signup_pict success">
                    <img src="/assets/images/success_pict.svg" />
                </div>
                <h2 className="signup_title welcome">ממתין לאימות פרופיל</h2>
                {/* <div>טקסט טקסט טקסט טקסט טקסט טקסט טקסט טקסט טקסט טקסט</div> */}
                <a href="#" className="edit_info_link red w-inline-block" onClick={logout}>
                    <div className="edit_link_info">
                        <h4 className="settink_link_title">התנתק</h4>
                    </div>
                </a>
            </div>
        </div>
    )
    else return (
        <div>
            {member.hasBeenAuthenticatedByPhone ?
                <ProfilePhotoVerify isFromNeedToVerifyProfile={true} />
                :
                <SmsVerificationContainer isFromNeedToVerifyProfile={true} />}
        </div>
    )
}

export default NeedToVerifyProfile;